// Veri Yönetimi ağacı "Sıra" hücresi (SetTreeEditor 600 satır kuralı): ↑↓ düğmeleri (klavye
// eşdeğeri — sürükle-bırakın erişilebilir karşılığı) + sürükleme açıkken ⋮⋮ görsel tutamaç
// (Finar rev-2 #4b/#12b/#14; tüm satır sürüklenir, tutamaç yalnız ipucu). Tıklama satıra yayılmaz.

import { KPI_COPY } from "../../lib/kpi-ui";
import { btnSmall, tdStyle } from "./kpi-form-styles";

export function SetTreeOrderCell(props: {
  label: string;
  canEdit: boolean;
  /** sürükleme açık (tutamaç çizilir) */
  draggable: boolean;
  onMove: (direction: -1 | 1) => void;
}): JSX.Element {
  return (
    <td style={tdStyle} onClick={(e) => e.stopPropagation()}>
      {props.canEdit ? (
        <span className="flex gap-1">
          {props.draggable ? (
            <span
              aria-hidden="true"
              className="kpi-drag-grip"
              data-testid="kpi-set-row-grip"
              title={KPI_COPY.reorder.hint}
              style={{ color: "var(--color-text-3)", letterSpacing: "-0.2em", padding: "0 4px" }}
            >
              ⋮⋮
            </span>
          ) : null}
          <button
            type="button"
            aria-label={`${props.label} yukarı taşı`}
            style={{ ...btnSmall, padding: "2px 8px", minWidth: 32 }}
            onClick={() => props.onMove(-1)}
          >
            ↑
          </button>
          <button
            type="button"
            aria-label={`${props.label} aşağı taşı`}
            style={{ ...btnSmall, padding: "2px 8px", minWidth: 32 }}
            onClick={() => props.onMove(1)}
          >
            ↓
          </button>
        </span>
      ) : null}
    </td>
  );
}
